export const ROUTE_LIST = "ROUTE_LIST";
export const CLEAR_LIST = "CLEAR_LIST";
